<template>
  <a-checkbox-group v-model:value="checkedList" :options="options" />
</template>

<script setup lang='ts'>
import { ref, reactive, computed } from 'vue'

const props = defineProps<{
  value: number
}>()

const emit = defineEmits(['update:value'])

const checkedList = computed({
  get() {
    if (props.value === 1) return [1]
    else if (props.value === 2) return [2]
    else if (props.value === 3) return [1, 2]
    return []
  },
  set(scopeList) {
    let sum = 0
    scopeList.forEach(a => sum += a)
    emit('update:value', sum)
  }
})

const options = [
  { label: '外卖', value: 1 },
  { label: '堂食', value: 2 },
]

</script>

<style lang='scss' scoped></style>